export default __webpack_public_path__ + "static/media/sweet-4.642c9737.jpg";